export default "__VITE_ASSET__S6hn4k3t__";